// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"category_nav_dropdownContainer__ZDwIV","dropdownBody":"category_nav_dropdownBody___9YYC","navLink":"category_nav_navLink__R2mtG"};